import { ApiService } from '../ApiService';
import { Message, MessagesView } from '../../models/Message';
import { ConversationView, ConversationItem } from '../../models/Conversation';
import { plainToClass } from '~/models/transform';
import { BaseListRequestParams } from '~/models/BaseRequestParams';
import { MessageListType } from '~/constants/lists';

export interface MessageListParams extends BaseListRequestParams {
  search?: string;
}

export interface ConversationParams extends BaseListRequestParams {
  nextPageSkip?: number;
  previousPageSkip?: number;
  withCount?: boolean;
}

export interface FlirtItem {
  Text: string;
}

export class MessagesService {

  // MESSAGE LISTS

  // Get messages by type
  static async getMessages(
    type: MessageListType = 'inbox',
    params: MessageListParams = {}
  ): Promise<MessagesView> {
    // Use 'inbox' when type is 'search'
    const apiType = type === 'search' ? 'inbox' : type;
    const response = await ApiService.get<MessagesView>(`messages/${apiType}`, params);
    return plainToClass(MessagesView, response);
  }

  // SINGLE MESSAGE OPERATIONS


  // Get conversation items (replies) for a message
  static async getConversation(id: number, params: ConversationParams = {}): Promise<ConversationView> {
    const response = await ApiService.get<ConversationView>(`messages/${id}/conversation`, params);
    return plainToClass(ConversationView, response);
  }

  // Add reply to a message
  static async addReply(id: number, conversationItem: Partial<ConversationItem>): Promise<void> {
    await ApiService.post(`messages/${id}/reply`, conversationItem);
  }

  // Mark message as read
  static async markAsRead(id: number): Promise<void> {
    await ApiService.post(`messages/${id}/read`, {});
  }

  // Mark message as unread
  static async markAsUnread(id: number): Promise<void> {
    await ApiService.post(`messages/${id}/unread`, {});
  }

  // Delete a message
  static async deleteMessage(id: number): Promise<void> {
    await ApiService.delete(`messages/${id}`);
  }

  // Undelete a message
  static async undeleteMessage(id: number): Promise<void> {
    await ApiService.post(`messages/${id}/undelete`, {});
  }

  // FLIRTS

  // Get available flirts
  static async getFlirts(): Promise<FlirtItem[]> {
    const response = await ApiService.get<FlirtItem[]>('messages/flirts');
    return response;
  }
}
